import { IFetchLeadsByOriginIdProtocol, IFetchLeadsByOriginIdProtocolRequest, IFetchLeadsByOriginIdProtocolResponse } from "../../protocols/leads/IFetchLeadsByOriginIdProtocol";
import { ILeadsRepository } from "../../repositories/ILeadsRepository";

export class FetchLeadsByOriginIdUseCase implements IFetchLeadsByOriginIdProtocol {
  constructor(private leadsRepository: ILeadsRepository){}
  async execute({originId}: IFetchLeadsByOriginIdProtocolRequest): Promise<IFetchLeadsByOriginIdProtocolResponse> {
   const leads = await this.leadsRepository.findManyByOrigin(originId)

   return {
    leads
   }
  }
}